import React, {useState} from "react";
import connection from "../../../connection";

import general from "../../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SweetAlert from "../../../components/SweetAlertWrapper";

import cursosStyle from "assets/jss/material-dashboard-pro-react/views/cursosStyle";
import Add from "@material-ui/icons/Add";
import CustomInput from "../../../components/CustomInput/CustomInput";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import MoreVert from "../../../../node_modules/@material-ui/icons/MoreVert";
import moment from "moment";
import Datetime from "../../../components/DatetimeWrapper";

class PaginaCursoFormacaoContinua extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curso: null
    };

    this.reloadInformacoesCurso = async () => {
      let curso = await connection.get("curso/detalhes_formacao_continua");

      this.setState({
        curso: curso,
        modulos: await connection.get("curso/modulos", {curso_id: curso.id}),
        modal: null
      })
    };

    this.reloadModulosCurso = async () => {
      this.setState({
        modulos: await connection.get("curso/modulos", {curso_id: this.state.curso.id}),
        modal: null
      })
    }
  }

  componentDidMount() {
    this.reloadInformacoesCurso();
  }

  render() {
    if (!this.state.curso)
      return "A carregar...";
    return <div>{this.state.modal}
      <this.CardModulos/>
    </div>
  }


  newModuloModal = async () => {
    const {classes} = this.props;
    let modelo_modulo = null;
    let modelo_modulo_inicio_prazo = new Date();
    let modelo_modulo_prazo = 12;

    let modulos = await connection.get("modulo/listagem", {continuos_apenas: true});

    //Filtrar módulos para ocultar usados
    let modulos_usados = this.state.modulos.modulos.map((mod) => mod.id);
    modulos = modulos.filter((modulo) => !modulos_usados.includes(modulo.id));

    let Content = () => {
      const [modelo_modulo_state, setModeloModulo] = useState(null);

      return <form autoComplete="off" className={classes.addForm}>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="modelo_area" className={classes.selectLabel}>
            Módulo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={modelo_modulo_state}
            onChange={(event) => {
              modelo_modulo = event.target.value;
              setModeloModulo(event.target.value);
            }}
            inputProps={{
              name: "modelo_modulo",
              id: "modelo_modulo"
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>{modulos.length > 0 ? "Escolha o módulo" : "Não existem mais módulos para esta área"}</MenuItem>
            {modulos.map((modulo) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={modulo.id}>{modulo.codigo} - {modulo.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <CustomInput
          labelText="Prazo para participação em meses"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            defaultValue: modelo_modulo_prazo,
            onChange: (e) => {
              modelo_modulo_prazo = e.target.value
            }
          }}
        />
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Data de início de prazo de participação
          </InputLabel>
          <Datetime
            onChange={(value) => {
              modelo_modulo_inicio_prazo = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={false}
            defaultValue={modelo_modulo_inicio_prazo}
          />
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Módulo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/modulo/novo", {
            modulo: modelo_modulo ? modelo_modulo : undefined,
            inicio_prazo_participacao: modelo_modulo_inicio_prazo,
            prazo_participacao_meses: modelo_modulo_prazo,
            obrigatorio: true,
            curso: this.state.curso.id,
          });
          this.reloadModulosCurso();
          general.success("Adicionado novo módulo.", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Criar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  editModuloModal = async (modulo) => {
    const {classes} = this.props;

    let modelo_modulo_inicio_prazo = modulo.inicio_prazo_participacao || new Date();
    let modelo_modulo_prazo = modulo.prazo_participacao_meses || 12;

    let Content = () => {
      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Módulo"
          id="modelo_modulo_editar"
          disabled
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: modulo.designacao,
            name: "modelo_modulo_editar",
            disabled: true
          }}
        />
        <CustomInput
          labelText="Prazo para participação em meses"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            defaultValue: modelo_modulo_prazo,
            onChange: (e) => {
              modelo_modulo_prazo = e.target.value
            }
          }}
        />
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Data de início de prazo de participação
          </InputLabel>
          <Datetime
            onChange={(value) => {
              modelo_modulo_inicio_prazo = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={false}
            defaultValue={modelo_modulo_inicio_prazo}
          />
        </FormControl>

      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Módulo</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("curso/modulo/editar", {
            curso: this.state.curso.id,
            modulo: modulo.id,
            inicio_prazo_participacao: modelo_modulo_inicio_prazo,
            prazo_participacao_meses: modelo_modulo_prazo,
            obrigatorio: true
          });
          this.reloadModulosCurso();
          general.success("Módulo editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  }

  confirmDeleteModulo = (modulo) => {
    console.log(modulo);
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Módulo"
          onConfirm={() => {
            connection.post("curso/modulo/apagar", {modulo: modulo.id, curso: this.state.curso.id}, (data) => {
              if (data.success) {
                this.reloadModulosCurso();
                general.success("Módulo '" + modulo.designacao + "' apagado com sucesso.", "Sucesso!");
              } else {
                general.error("Por favor tente novamente mais tarde.", "Erro!");
              }
            })
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Atenção! Está prestes a apagar o módulo '{modulo.designacao}'. Esta ação é irreversível.
        </SweetAlert>
      )
    });
  }

  CardModulos = () => {
    const {classes} = this.props;

    let modulos = this.state.modulos.modulos;
    modulos.sort((a, b) => a.id - b.id).sort((a, b) => b.obrigatorio - a.obrigatorio);

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Gerir Módulos</h4>
        </div>
        <p>Adicione ou remova módulos em que os dirigentes terão de participar durante a formação contínua.<br/>Defina para cada um o prazo em que a aprovação nos módulos deverá ser feita e defina o momento a partir do qual o prazo deverá ser contado (para os dirigentes que chegaram depois à formação contínua será assumida como data de início do prazo a data em que o dirigente iniciou o seu percurso contínuo - primeiro 1 de outubro após a investidura)</p>
      </CardHeader>
      <CardBody>
        <GridContainer>
          {modulos.map(modulo => <GridItem xs={12} sm={6} md={6} key={"modulo" + modulo.id}>
            <Card color="primary" className={classes.moduloCard}>
              <CardHeader color="primary" icon className={classes.moduleCardHeader}>
                <h4 className={classes.innerCardTitle}>{modulo.designacao}</h4>
                {!modulo.origem_template && <div style={{position: "absolute", top: -3, right: -16}}>
                  <CustomDropdown
                    hoverColor="info"
                    buttonText={<MoreVert/>}
                    caret={false}
                    buttonProps={{
                      justIcon: true,
                      style: {marginBottom: "0"},
                      simple: true,
                      round: true
                    }}
                    dropdownList={[
                      {
                        label: "Editar",
                        onClick: () => this.editModuloModal(modulo)
                      },
                      {
                        label: "Apagar",
                        onClick: () => this.confirmDeleteModulo(modulo)
                      }
                    ]}
                  />
                </div>}
              </CardHeader>
              <CardBody className={classes.moduloCardBody}>
                <table>
                  <tr>
                    <td>Início de prazo:</td>
                    <td><span>{moment(modulo.inicio_prazo_participacao).format("DD/MM/YYYY")}</span></td>
                  </tr>
                  <tr>
                    <td>Prazo de participação:</td>
                    <td><span>{modulo.prazo_participacao_meses} meses</span></td>
                  </tr>
                </table>
              </CardBody>
            </Card>
          </GridItem>)}
          <GridItem xs={12} sm={6} md={6}>
            <Button
              justIcon
              round
              simple
              onClick={() => {
                this.newModuloModal();
              }}
              color="primary"
              className={classes.addModuloButton}
            >
              <Add/>
            </Button>
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }
}

export default withStyles(cursosStyle)(PaginaCursoFormacaoContinua);
